export default {
  title: {
    id: 'asp_action_bar_send_message_step_title_seller_side',
    defaultMessage: 'Send a message to the agent',
  },
  toastTitle: {
    id: 'asp_action_bar_send_message_step_error_toast_title',
    defaultMessage: "Hmm, that didn't work.",
  },
  toastLabel: {
    id: 'asp_action_bar_send_message_step_error_toast_label',
    defaultMessage: 'Please try again.',
  },
  submit: {
    id: 'asp_action_bar_send_message_with_template_selector_submit_button',
    defaultMessage: 'Send message',
  },
}
